var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('price-element-nights',{attrs:{"amount":_vm.service.duration},on:{"update:amount":function($event){return _vm.$set(_vm.service, "duration", $event)}}}),_vm._v(" "),_c('price-element-breakfast',{attrs:{"breakfast":_vm.service.breakfast},on:{"update:breakfast":function($event){return _vm.$set(_vm.service, "breakfast", $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2768b34e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/price/Perperson.vue
// module id = null
// module chunks = 